import { IDictionary, IStandarDataTableColumn } from "@ioip/core/lib";
import React from "react";
import { IAttributeSchema } from "../../data";
import { IDataTableColumnSchema } from "../../types/IDataTableColumn";
import { UXDataTableColumn } from "../components/UXDataTableColumn";
import CDataTable from "./CDataTable";
import CField from "./CField";

export interface IJSDataTableColumnProps {
    datatable: CDataTable;
    schema: IDataTableColumnSchema;
    attribute: IAttributeSchema;
}

export class JSDataTableColumn {

    __props: IJSDataTableColumnProps;
    __fluent: IStandarDataTableColumn<any>;

    constructor(props: IJSDataTableColumnProps) {
        this.__props = props;
        if (this.__props.schema.attribute == null)
            props.datatable.getForm().fields.where(x => x.id.toString() == this.fieldId);
    }

    get visible(): boolean {
        return true;
    }

    get headerText(): string {
        return this.__props.schema.headerText;
    }

    get customValue(): string {
        return this.__props.schema.customValue;
    }

    get visibleRule(): string {
        return this.__props.schema.visibleRule;
    }

    get id(): string {
        return this.__props.schema.id;
    }

    get maxWidth(): number {
        return this.__props.schema.maxWidth;
    }

    get order(): number {
        return this.__props.schema.order;
    }

    /**
     * ID del campo sobre el cual funciona la columna
     */
    get fieldId(): string {
        return this.__props.schema.fieldId;
    }

    get minWidth(): number {
        return this.__props.schema.minWidth;
    }

    get attribute(): IAttributeSchema {
        return this.__props.attribute;
    }

    get datatable(): CDataTable {
        return this.__props.datatable;
    }

    get field(): CField {
        return this.__props.datatable.getForm().fields.where(x => x.id.toString() == this.fieldId).firstOrDefault();
    }

    get fluentUi(): IStandarDataTableColumn<any> {
        if (this.__fluent == null) {
            this.__fluent = {
                name: this.__props.schema.headerText,
                minWidth: this.__props.schema.minWidth,
                maxWidth: this.__props.schema.maxWidth,
                isResizable: typeof this.__props.schema.isResizable === 'boolean' ? this.__props.schema.isResizable : true,
                onRender: (row: IDictionary<any>) => <UXDataTableColumn
                    key={this.id}
                    column={this}
                    row={row}
                />
            };
        }
        return this.__fluent;
    }


}